import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IHttpErrorPayload, HttpRequestPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from 'src/app/core/services/http-provider/http-provider.service';
import { IResultNavigationDetails, IResultPageState } from '../models/pre-login-result-page.model';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth.service';
import { MobileService } from 'src/app/mobile.services';
import { TranslateService } from '@ngx-translate/core';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { InfoPopupComponent } from 'src/app/core/components/popup/info-popup/info-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class  PreLoginResultService {
  constructor(
    public translate: TranslateService,
    private _dialog: MatDialog) {
}


paymentData: any;
private transactionModules = ["OTP"];

private title: string = 'Done';
private message: string;
private alertType: 'Success' | 'Warning' | 'Failed';
private navigationDtls: IResultNavigationDetails[] ;
private resultPayload: IHttpSuccessPayload<any> | IHttpErrorPayload;
private serviceCode : string ;

 setTitle(title: string) {
  this.title = title;
}

setService(serviceCode: string) {
  this.serviceCode = serviceCode;
}

 setResultPayload(resultPayload: IHttpSuccessPayload<any> | IHttpErrorPayload) {
  this.resultPayload = resultPayload;
}

setPaymentData(data) {
  this.paymentData = data;
}

setSuccess(successData?, additionNavigation = null){
  this.alertType = 'Success';
  if(!successData){
    this.navigationDtls = [{
      path : ['home'],
      state : {},
      btnLabel : 'Close',
     }];
     this.message = '';
     this.title = 'Success';
  }else{
    this.navigationDtls = [{
      path : [successData.path],
      state : {},
      btnLabel : successData.btnLabel,
     }];
     this.message = successData.message;
     this.title = successData.title;
  }

  this.title = 'Successful';
}

setFailure(failureData?){
  if(!failureData){
    this.alertType = 'Failed';
    this.navigationDtls = [{
      path : ['login'],
      state : {},
      btnLabel : 'Retry',
     }];
     this.message = this.translate.instant('RESULTPAGEMESSAGE.COMMONFAILUREMESSAGE');
     this.title = this.translate.instant('RESULTPAGEMESSAGE.COMMONFAILURETITLE');
  }else{
    this.alertType = 'Failed';
    this.navigationDtls = [{
      path : [failureData.path],
      state : {},
      btnLabel : failureData.btnLabel,
     }];
     this.message = failureData.message;
     this.title = failureData.title;
  }

}

get resultPageData(): IResultPageState {
  return {
    title: this.title,
    message: this.message,
    alertType: this.alertType,
    navigationDtls: this.navigationDtls,
    resultPayload: this.resultPayload,
    serviceCode : this.serviceCode,
    paymentData: this.paymentData
  };
}

resetResultPageData() {
  this.title = '';
  this.message = '';
  this.alertType = undefined;
  this.navigationDtls = [];
  this.resultPayload = undefined;
  this.serviceCode = '';
  this.paymentData = undefined;
}

openResultPage() {
    let dialogRef;
    let _data:IPopupScreenData = {
      screenData: {
        resultPageData: this.resultPageData,
      },
      screenTitle: "",
      component: 'preLoginResultPage'
    }
    dialogRef = this._dialog.open(InfoPopupComponent, {
      width: '100%',
      data: _data,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.resetResultPageData();
      console.log('The dialog was closed');
    });
}
  
}
